import ImageLoader from 'react-load-image';
import Gravatar from 'react-gravatar';

const CustomAvatar = ({ name, email, size, style, className }) => {
  if (email) {
    return <Gravatar email={email} size={size} default="mm" className={className} />;
  }

  const getInicials = () => {
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .toUpperCase();
  };

  return (
    <div style={{ ...style, fontSize: '180%', backgroundColor: '#7E3794', color: '#fff' }} className={className}>
      <div className="h-100 d-flex align-items-center justify-content-center">{getInicials()}</div>
    </div>
  );
};

const Avatar = ({ name, email, alt, src, className, size }) => {
  const style = { width: size, height: size, margin: 'auto' };
  return (
    <ImageLoader src={src}>
      <img alt={alt} src={src || ''} className={className} style={style} />
      <CustomAvatar name={name} email={email} size={size} style={style} className={className} />
      <CustomAvatar name={name} email={email} size={size} style={style} className={className} />
    </ImageLoader>
  );
};

export default Avatar;
